/* NAVIGATION (with Mobile Menu Animation Fix) */

export function initNavigation() {
  const toggle = document.querySelector('.nav-toggle');
  const menu   = document.querySelector('.nav-menu');
  if (!toggle || !menu) return;

  const open = () => {
    toggle.classList.add('active');
    menu.classList.add('active');
    document.body.classList.add('menu-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close navigation menu');

    // Set focus to first menu item after animation starts
    const firstLink = menu.querySelector('.nav-link');
    setTimeout(() => firstLink && firstLink.focus(), 100);
  };

  const close = () => {
    toggle.classList.remove('active');
    menu.classList.remove('active');
    document.body.classList.remove('menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open navigation menu');
    toggle.focus();
  };

  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    toggle.classList.contains('active') ? close() : open();
  });

  // Close when clicking a nav link
  menu.querySelectorAll('.nav-link').forEach(link => {
    link.addEventListener('click', () => {
      if (toggle.classList.contains('active')) close();
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && toggle.classList.contains('active')) {
      close();
    }
  });

  // Trap focus inside menu when open (Accessibility)
  menu.addEventListener('keydown', (e) => {
    if (!toggle.classList.contains('active')) return;

    /* A collapsed disclosure panel is visibility:hidden, so its links are not
       focusable — but they are still in the DOM, and counting them made the
       last "focusable" element unreachable, which broke the wrap. */
    const focusableElements = Array.from(menu.querySelectorAll('a, button, [tabindex="0"]'))
      .filter(el => !el.closest('.nav-panel:not(.open)'));
    if (!focusableElements.length) return;
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (toggle.classList.contains('active') &&
        !menu.contains(e.target) &&
        !toggle.contains(e.target)) {
      close();
    }
  });
}


